// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment, useState, useContext} from 'react';
import {guess} from 'zuser_agent';
import {Modal} from '../../../../shared/ui/modal';
import {img_url} from '../img_url';
import {Button} from '../../../../shared/button';
import styles from './br_download.module.less';
import {useHistory, useLocation} from 'react-router-dom';
import {perr} from 'hola_pub_util';
import {use_translation_v} from '../../lib/trans_v';
import {use_download} from '../../shared/use_download';
import {use_agree_dialog} from '../use_agree_dialog';
import {Browser_consent} from '../vpn_config/consent';
// @ts-ignore
import {App_context} from 'hola_app_context';

interface i_br_download_props {
    btn_cls: string;
    click_perr: string;
    pp: string;
    after_download?: boolean;
    caption?: string;
    agree_dialog?: (props:object_of<any>)=>JSX.Element;
    need_agree?: boolean;
    experiment_after_dl_flow?: boolean;
    filename?: string;
}

export const Br_download = ({btn_cls, click_perr, pp, caption,
    after_download, agree_dialog, need_agree,
    experiment_after_dl_flow, filename}:i_br_download_props)=>{
    const {is_client} = useContext(App_context);
    const {mobile, os} = guess();
    const [is_open, set_is_open] = useState(false);
    const {pathname} = useLocation();
    const history = useHistory();
    const {T} = use_translation_v();
    const {download_br, do_agree} = use_download({need_agree, pref: pp,
        filename});
    const [toggle, Agree_dialog] = use_agree_dialog({on_agree: do_agree,
        agree_dialog});
    const [consent_opened, set_consent_opened] = useState(false);
    const is_mac_consent = os=='macos';
    const finish_downloading = ()=>{
        download_br({cb: ()=>{
            if (after_download)
            {
              const {search, href: w_href} = window.location;
              let install_popup_q_param = pathname+search;
              if (!w_href.includes('app') && experiment_after_dl_flow)
              {
                install_popup_q_param = install_popup_q_param+
                  `${w_href.includes('?')? '&' : '?'}step=install&app=browser`;
              }
                const page = experiment_after_dl_flow
                  ? install_popup_q_param
                  : '/after_download_br?s=install&browser=1';
                return void history.push(page);
            }
            return void history.push(pathname
                +'?flow=hola_browser&step=install&browser_enabled=1');
        }});
    };
    const start_click = ()=>{
        perr({id: click_perr});
        if (mobile)
        {
            set_is_open(true);
            return;
        }
    };
    const on_btn_click = is_mac_consent ? ()=>{
        start_click();
        set_consent_opened(true);
    } : ()=>{
        start_click();
        if (need_agree)
            toggle(true);
        finish_downloading();
    };
    return <Fragment>
      <Modal is_open={is_open} width={335} on_close={()=>{
        set_is_open(false);
      }}>
        <div className={styles.modal_root}>
          <img src={img_url('mascot/best_holi.png')} width={87} height={48}
            alt="best_holi" className="lazyload"/>
          <h2><T>browser.oops</T></h2>
          <h5><b><T>You are browsing from mobile device</T>.</b></h5>
          <p><T components={{b: <b/>}}>
            browser.mobile_text_description</T></p>
        </div>
      </Modal>
      {Agree_dialog}
      {is_client && is_mac_consent ?
        <Browser_consent
          on_close={()=>{
            set_consent_opened(false);
          }}
          on_agree={()=>{
            set_consent_opened(false);
            finish_downloading();
          }}
          consent_opened={consent_opened}/> : null}
        <Button caption={<T i18nKey={caption || 'browser.btn_title'}/>}
          cls={btn_cls} arrow size={'lg'} on_click={on_btn_click}/>
    </Fragment>;
};
